import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Redirect, RouteComponentProps } from 'react-router-dom'
import { IonButton, IonButtons, IonIcon, IonTitle } from '@ionic/react'

import { BackButton } from '@components/atoms/BackButton'
import { Main } from '@components/templates/main'
import { Loading } from '@/components/atoms/Loading'

import { useContestLeaderboard } from '@services/contest'
import { useContestInfo } from '@/lib/hooks/useContestInfo'

import { LeaderboardList } from './LeaderboardList'

export const Leaderboard: FC<RouteComponentProps<{ contestId: string }>> = ({
  match,
}) => {
  const {
    params: { contestId },
  } = match

  const {
    data: leaderboardList,
    isLoading: isContestLeaderboardLoading,
    refetch,
  } = useContestLeaderboard(contestId)
  const { data: contestData, isLoading: isContestDataLoading } =
    useContestInfo(contestId)
  const { t } = useTranslation('common')

  if (!isContestDataLoading && contestData?.contest?.hideVotesCount) {
    return <Redirect to={`/contest/${contestId}`} />
  }

  const header = (
    <>
      <IonButtons slot="start">
        <BackButton defaultHref="/feed" />
      </IonButtons>
      <IonTitle class="text-center">
        {!isContestDataLoading && contestData?.contest?.name}
      </IonTitle>
      <IonButtons slot="end">
        <IonButton>
          <IonIcon slot="icon-only" />
        </IonButton>
      </IonButtons>
    </>
  )

  return (
    <Main
      header={header}
      refetch={refetch}
      headTitle={t('common.head.title.leaderboard')}
    >
      {!isContestLeaderboardLoading ? (
        <LeaderboardList items={leaderboardList.items} />
      ) : (
        <Loading />
      )}
    </Main>
  )
}
